import * as Yup from "yup";

import {
  CoopConsentFormValues,
  CoopSelectMembershipFormValues,
  HasAkaUnionAffiliationConsentFormValues,
  HuseierneMembershipStatus,
  HuseierneMembershipStatusFormValues,
  IsHuseierneMembershipConfirmationFormValues,
} from "Components/Form/Partner/partnerFormValuesInterfaces";

import { TextManager } from "Components/TextContext/TextManager";

const { getText } = TextManager;

export const validationSchemaCoopConsent =
  (): Yup.ObjectSchema<CoopConsentFormValues> => {
    return Yup.object({
      coopConsent: Yup.boolean()
        .required(getText("partnercoop.validation.consent"))
        .oneOf([true], getText("partnercoop.validation.consent")),
    }).defined();
  };

export const validationSchemaCoopSelectMembership =
  (): Yup.ObjectSchema<CoopSelectMembershipFormValues> => {
    return Yup.object({
      coopSelectedMembership: Yup.string().required(
        getText("partnercoop.validation.choosemembership"),
      ),
    }).defined();
  };

export const validationSchemaHuseierneMembershipStatus =
  (): Yup.ObjectSchema<HuseierneMembershipStatusFormValues> => {
    return Yup.object({
      huseierneMembershipStatus:
        Yup.mixed<HuseierneMembershipStatus>().required(
          getText("partnerhuseierne.validation.huseiernemembershipstatus"),
        ),
    }).defined();
  };

export const validationSchemaIsHuseierneMembershipConfirmation =
  (): Yup.ObjectSchema<IsHuseierneMembershipConfirmationFormValues> => {
    return Yup.object({
      wantsHuseierneMembershipConfirmation: Yup.boolean().when(
        "huseierneMembershipStatus",
        {
          is: (huseierneMembershipStatus: HuseierneMembershipStatus) =>
            huseierneMembershipStatus ===
            HuseierneMembershipStatus.WANTS_HUSEIERNE_MEMBERSHIP,
          then: (schema) =>
            schema
              .oneOf(
                [true],
                getText(
                  "partnerhuseierne.validation.wantshuseiernemembershipconfirmation",
                ),
              )
              .required(
                getText(
                  "partnerhuseierne.validation.wantshuseiernemembershipconfirmation",
                ),
              ),
        },
      ),
      isHuseierneMembershipConfirmation: Yup.boolean()
        .oneOf(
          [true],
          getText(
            "partnerhuseierne.validation.ishuseiernemembershipconfirmation",
          ),
        )
        .required(
          getText(
            "partnerhuseierne.validation.ishuseiernemembershipconfirmation",
          ),
        ),
    }).defined();
  };

export const validationSchemaHasAkaUnionAffiliationConsent =
  (): Yup.ObjectSchema<HasAkaUnionAffiliationConsentFormValues> => {
    return Yup.object({
      hasAkaUnionAffiliationConsent: Yup.boolean()
        .oneOf(
          [true],
          getText("partneraka.validation.hasakaunionaffiliationconsent"),
        )
        .required(
          getText("partneraka.validation.hasakaunionaffiliationconsent"),
        ),
    }).defined();
  };
